__turbopack_context__.v({
  "annotation": "axcelerate-analytics-demo-module__kixo5G__annotation",
  "arrive": "axcelerate-analytics-demo-module__kixo5G__arrive",
  "dashboard": "axcelerate-analytics-demo-module__kixo5G__dashboard",
  "detail": "axcelerate-analytics-demo-module__kixo5G__detail",
  "header": "axcelerate-analytics-demo-module__kixo5G__header",
  "scene": "axcelerate-analytics-demo-module__kixo5G__scene",
  "steps": "axcelerate-analytics-demo-module__kixo5G__steps",
  "summary": "axcelerate-analytics-demo-module__kixo5G__summary",
  "tabs": "axcelerate-analytics-demo-module__kixo5G__tabs",
});
